import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
  selector: 'app-gip-confirm',
  standalone: true,
  imports: [CommonModule, ConfirmDialogModule],
  templateUrl: './custom-confirm.component.html'
})
export class GIPConfirmComponent {
  constructor() { }
}
